import { Injectable } from '@angular/core';
// import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ShopItem, ShopItems } from '../models/shop/item';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Cart, Carts } from '@models/shop/cart';
import { SessionStorageService } from 'ngx-webstorage';

@Injectable({
  providedIn: 'root'
})
export class ShopService {
  private readonly baseUrl;

  constructor(private http: HttpClient, private translateService: TranslateService, private sessionStorage: SessionStorageService) {
    this.baseUrl = environment.serverBaseUrl;
  }

  calculateCustomPackage(shopComponentInstance, type, amount): Observable<any> {
    return this.http.get<ShopItems>(this.baseUrl + 'shop/items/customized/' + type + '/' + amount).pipe(
      map(data => {
        return ShopItems.deserialize({
          data: (data && (data as any).items ? ((data as any).items as Array<string>) : []).map(data2 => {
            (data2 as any).items = (data2 as any).shopItems;
            (data2 as any).itemquantity = amount;
            (data2 as any).messagetype = type;
            const it = ShopItem.deserialize(data2);
            it.shopInit(shopComponentInstance, this.sessionStorage, this.translateService);
            return it;
          })
        });
      })
    );
  }

  getItems(shopComponentInstance): Observable<ShopItems> {
    return this.http.get<ShopItems>(this.baseUrl + 'shop/items').pipe(
      // return this.http.get<any>(this.baseUrl + 'user/ips/allowed-subnets').pipe(
      map(data => {
        const dataItems = (data && (data as any).items ? ((data as any).items as Array<string>) : []).map(data2 => {
          (data2 as any).items = (data2 as any).shopItems
            .filter(x => x !== null) // Filter out in case api returns shopItems: [null]
            .map(x => {
              return x;
            });

          const it = ShopItem.deserialize(data2);
          it.shopInit(shopComponentInstance, this.sessionStorage, this.translateService, (data as any).options);
          return it;
        });
        // Add renewable smsin
        if ((data as any).options.renewableSims) {
          const data2 = {
            label: 'list-sr-shop-items-renew',
            items: (data as any).options.renewableSims
          };
          const srShopItems = dataItems.find(x => x.label === 'list-sr-shop-items');
          if (srShopItems) {
            const newItems = [];
            data2.items.map(x => {
              const availableMonths = srShopItems.items.filter(y => (x.shared ? y.category === 'srv_smss' : y.category !== 'srv_smss'));
              availableMonths.map(y => {
                newItems.push({
                  category: x.shared ? 'srv_smss' : 'srv_sms',
                  // monthsValidity: x.monthsValidity,
                  monthsValidity: y.monthsValidity,
                  idShopItem: y.idShopItem,
                  shop_subscription_monthprice: x.price,
                  shop_subscription_totalprice: x.price,
                  number: x.idSim,
                  keyword: x.keyword
                });
              });
            });
            data2.items = newItems;
            const it = ShopItem.deserialize(data2);
            it.shopInit(shopComponentInstance, this.sessionStorage, this.translateService, (data as any).options);
            dataItems.push(it);
          }
        }
        return ShopItems.deserialize({
          data: dataItems
        });
      })
    );
  }

  getItemsBySubaccount(shopComponentInstance, subaccountId: number): Observable<ShopItems> {
    return this.http.get<ShopItems>(this.baseUrl + 'shop/items/subaccount/' + subaccountId).pipe(
      // return this.http.get<any>(this.baseUrl + 'user/ips/allowed-subnets').pipe(
      map(data => {
        const dataItems = (data && (data as any).items ? ((data as any).items as Array<string>) : []).map(data2 => {
          (data2 as any).items = (data2 as any).shopItems
            .filter(x => x !== null) // Filter out in case api returns shopItems: [null]
            .map(x => {
              return x;
            });
          const it = ShopItem.deserialize(data2);
          it.shopInit(shopComponentInstance, this.sessionStorage, this.translateService, (data as any).options);
          return it;
        });
        // Add renewable smsin
        if ((data as any).options.renewableSims) {
          const data2 = {
            label: 'list-sr-shop-items-renew',
            items: (data as any).options.renewableSims
          };
          const srShopItems = dataItems.find(x => x.label === 'list-sr-shop-items');
          if (srShopItems) {
            const newItems = [];
            data2.items.map(x => {
              const availableMonths = srShopItems.items.filter(y => (x.shared ? y.category === 'srv_smss' : y.category !== 'srv_smss'));
              availableMonths.map(y => {
                newItems.push({
                  category: x.shared ? 'srv_smss' : 'srv_sms',
                  // monthsValidity: x.monthsValidity,
                  monthsValidity: y.monthsValidity,
                  idShopItem: y.idShopItem,
                  shop_subscription_monthprice: x.price,
                  shop_subscription_totalprice: x.price,
                  number: x.idSim,
                  keyword: x.keyword
                });
              });
            });
            data2.items = newItems;
            const it = ShopItem.deserialize(data2);
            it.shopInit(shopComponentInstance, this.sessionStorage, this.translateService, (data as any).options);
            dataItems.push(it);
          }
        }
        return ShopItems.deserialize({
          data: dataItems
        });
      })
    );
  }

  addToCart(shopItemId, options) {
    /*
    options: quantity, category, idNation
     */
    if (!options.quantity) {
      options.quantity = 1;
    }
    if (!options.category) {
      options.category = 1;
    }
    if (!options.operation) {
      options.operation = 'standard_item';
    }
    return this.http.put(this.baseUrl + 'shop/items', { ...options, idShopItem: shopItemId }, { responseType: 'text' });
  }

  getCarts(page: number = null, size: number = null): Observable<Carts> {
    let queryParams = new HttpParams();
    if (page) {
      queryParams = queryParams.set('page', String(page));
    }
    if (size) {
      queryParams = queryParams.set('size', String(size));
    }
    return this.http.get<Response>(this.baseUrl + 'shop/cart?' + queryParams.toString().replace(/\+/gi, '%2B')).pipe(
      map((data: any) => {
        return Carts.deserialize({
          data: (data && (data as any).data ? ((data as any).data as Array<string>) : []).map(data2 => Cart.deserialize(data2)),
          total: (data as any).total
        });
      })
    );
  }

  getCurrentCart(): Observable<Cart> {
    return this.http.get<Response>(this.baseUrl + 'shop/cart/current').pipe(map(data => Cart.deserialize(data)));
  }

  getInvoiceHtml(id): Observable<any> {
    // @ts-ignore
    return this.http.get<any>(this.baseUrl + 'shop/cart/invoice-html/' + id, { observe: 'response', responseType: 'text' });
  }

  deleteCart(id) {
    return this.http.delete(this.baseUrl + 'shop/cart/' + id);
  }

  addPromoCodeToShopCart(code): Observable<Cart> {
    return this.http.post<Response>(this.baseUrl + 'shop/cart/current/discount-code', code).pipe(map(data => Cart.deserialize(data)));
  }

  removePromoCodeToShopCart(): Observable<Cart> {
    return this.http.delete<Response>(this.baseUrl + 'shop/cart/current/discount-code/', {}).pipe(map(data => Cart.deserialize(data)));
  }

  updateQuantityCartItem(idShopItem, quantity, idSubaccount?) {
    const params = {
      idShopItem,
      quantity
    };
    return this.http.post<Response>(this.baseUrl + 'shop/items', params).pipe(map(data => Cart.deserialize(data)));
  }

  deleteShopCartItem(idShopItem, idSubaccount?) {
    const params = {
      idShopItem,
      idSubaccount
    };

    const options = { responseType: 'text' as 'json', body: params };

    return this.http.delete<Response>(this.baseUrl + 'shop/items', options).pipe(map(data => Cart.deserialize(data)));
  }

  lockCurrentReadyShopCart(paymentMethod): Observable<Cart> {
    return this.http
      .post(this.baseUrl + 'shop/cart/current', {
        paymentMethod
      })
      .pipe(map(data => Cart.deserialize(data)));
  }
}
